import React, { useEffect, useState } from 'react';
import { compose } from 'redux';
import { PropTypes } from 'prop-types';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import {
  Field,
  withFormik,
} from 'formik';
import {
  Form as SemanticForm,
  Grid,
  Dimmer,
  Loader,
  Radio,
} from 'semantic-ui-react';

import { captureException, InputFormField } from '@playbookux/playbook-web-core';
import withDashboardSidebar from '../../components/with-dashboard-sidebar';

import SelectFormField from '../../../core/components/select-form-field';
import Categorizing from '../../../core/components/categorizing-select-list';

import {
  seniority,
  companySize,
  industry,
  educationLevelOptions,
} from './options';

import {
  Container,
  SelectsContainer,
  BottomButton,
  ContainerButtons,
  Typography,
  CategorizingLabel,
  ErrorMessage,
  RadioContainer,
} from './styles';
import { getUser, updateUserCurrentPosition } from './graphql';
import api from '../../../core/services/api';
import { getCatSubCat } from '../../../core/utils/get-cat-subcat';

const EditTester = (props) => {
  const {
    values,
    match,
    setValues,
    setFieldValue,
    handleSubmit,
    history,
    status,
  } = props;
  const [userName, setUserName] = useState('');
  const [valuesCatJobs, setValuesCatJobs] = useState([]);
  const [jobInfoState, setJobInfoState] = useState('');
  const [errorResponse, setErrorResponse] = useState();
  const [isLoading, setIsLoading] = useState(true);

  const getJobsList = async () => {
    try {
      const response = await api.listJobCategories();
      const categoryJobs = getCatSubCat(response);

      setValuesCatJobs(categoryJobs);
    } catch (error) {
      captureException('GET_JOBS_LIST_FAILED', error);
    }
  };

  const handleGetUser = async () => {
    try {
      const result = await getUser(match.params.id);
      const { profile, testers } = result.user;
      let { linkedinFields } = profile;
      const {
        educationLevel, currentPosition, jobCategories, jobInfo, firstName, lastName,
      } = profile;

      if (!linkedinFields) {
        linkedinFields = {};
      }

      const userInterviewsParticipantId = testers[0] ? testers[0].userInterviewsParticipantId : null;
      setJobInfoState(userInterviewsParticipantId ? 'job_title' : jobInfo);

      setValues({
        educationLevel: educationLevel || '',
        linkedinUrl: linkedinFields.linkedinUrl || '',
        jobsSelected: jobCategories || [],
        jobInfo: userInterviewsParticipantId ? 'job_title' : jobInfo,
        currentPosition: {
          company: {
            name: _.get(currentPosition, 'company.name', ''),
            size: _.get(currentPosition, 'company.size', ''),
            industry: _.get(currentPosition, 'company.industry', ''),
          },
          startDate: {
            month: _.get(currentPosition, 'startDate.month', ''),
            year: _.get(currentPosition, 'startDate.year', ''),
          },
          endDate: null,
          title: _.get(currentPosition, 'title', ''),
          description: _.get(currentPosition, 'description', ''),
          seniority: _.get(currentPosition, 'seniority', ''),
        },
      });
      setUserName(`${firstName} ${lastName}`);
      setIsLoading(false);
    } catch (error) {
      setErrorResponse(true);
      captureException('GET_USE_FAILED', error);
    }
  };

  useEffect(() => {
    getJobsList();
    handleGetUser();
  }, []);

  const callbackCatAndSubCat = (valuesCatAndSubCat) => {
    setFieldValue('jobsSelected', valuesCatAndSubCat);
  };

  const onJobInfoChange = (e, { value }) => {
    setJobInfoState(value);
    setFieldValue('jobInfo', value);
  };

  if (errorResponse) {
    return (
      <Container>
        <ErrorMessage>
          Error while retrieving the tester.
        </ErrorMessage>
      </Container>
    );
  }

  return (
    <Container>
      {status && status.isLoading && (
        <Dimmer active={status.isLoading} inverted>
          <Loader inverted data-loader="edit-tester-loader" />
        </Dimmer>
      )}
      {status && status.error && (
        <Typography>
          Error while sending profile information. Please try again.
        </Typography>
      )}

      <SemanticForm as="div">
        <Typography>
          {`Person: ${userName}`}
        </Typography>

        <SemanticForm.Field>
          <Field
            labelFontSize="14px"
            labelText="Linkedin URL"
            name="linkedinUrl"
            component={InputFormField}
          />
        </SemanticForm.Field>

        <SelectsContainer>
          <SemanticForm.Field>
            <Field
              labelFontSize="14px"
              label="Industry"
              name="currentPosition.company.industry"
              isMulti={false}
              isCreatable={false}
              options={industry}
              icon="chevron down"
              component={SelectFormField}
            />
          </SemanticForm.Field>
          <SemanticForm.Field>
            <Field
              labelFontSize="14px"
              label="Company Size"
              name="currentPosition.company.size"
              isMulti={false}
              isCreatable={false}
              options={companySize}
              icon="chevron down"
              component={SelectFormField}
            />
          </SemanticForm.Field>
          <SemanticForm.Field>
            <Field
              labelFontSize="14px"
              label="Seniority"
              name="currentPosition.seniority"
              isMulti={false}
              isCreatable={false}
              options={seniority}
              icon="chevron down"
              component={SelectFormField}
            />
          </SemanticForm.Field>

          <SemanticForm.Field>
            <Field
              labelFontSize="14px"
              label="Education Level"
              name="educationLevel"
              isMulti={false}
              isCreatable={false}
              options={educationLevelOptions}
              icon="chevron down"
              component={SelectFormField}
            />
          </SemanticForm.Field>

          <SemanticForm.Field>
            <RadioContainer>
              <Radio
                label="Job roles"
                name="jobInfo"
                value="job_roles"
                checked={jobInfoState === 'job_roles'}
                onChange={onJobInfoChange}
              />
              <Radio
                label="Job title"
                name="jobInfo"
                value="job_title"
                checked={jobInfoState === 'job_title'}
                onChange={onJobInfoChange}
              />
            </RadioContainer>
          </SemanticForm.Field>

          <SemanticForm.Field>
            <Field
              labelFontSize="14px"
              labelText="Job Title"
              name="currentPosition.title"
              component={InputFormField}
            />
          </SemanticForm.Field>
        </SelectsContainer>

        {!isLoading && (
          <>
            <CategorizingLabel>Job Roles</CategorizingLabel>
            <Categorizing
              category={valuesCatJobs}
              callbackCatAndSubCat={callbackCatAndSubCat}
              type="jobs"
              limit={12}
              label="label"
              values={values.jobsSelected || []}
            />
          </>
        )}

      </SemanticForm>

      <ContainerButtons>
        <Grid centered>
          <Grid.Row centered columns={3}>
            <Grid.Column>
              <Grid centered>
                <BottomButton
                  circular
                  onClick={() => history.push('/testers')}
                  type="submit"
                >
                  Cancel
                </BottomButton>
              </Grid>
            </Grid.Column>
            <Grid.Column>
              <Grid centered>
                <BottomButton
                  next
                  circular
                  type="submit"
                  onClick={handleSubmit}
                >
                  Send
                </BottomButton>
              </Grid>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </ContainerButtons>
    </Container>
  );
};

EditTester.propTypes = {
  values: PropTypes.shape({
    educationLevel: PropTypes.string,
    linkedinUrl: PropTypes.string,
    jobInfo: PropTypes.string,
    currentPosition: PropTypes.shape({
      company: PropTypes.shape({
        name: PropTypes.string,
        size: PropTypes.string,
        industry: PropTypes.string,
      }),
      startDate: PropTypes.shape({
        month: PropTypes.string,
        year: PropTypes.string,
      }),
      endDate: PropTypes.string,
      title: PropTypes.string,
      description: PropTypes.string,
      seniority: PropTypes.string,
    }),
    jobsSelected: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  handleSubmit: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  status: PropTypes.shape({
    isLoading: PropTypes.bool,
    error: PropTypes.bool,
  }),
  setFieldValue: PropTypes.func.isRequired,
  setValues: PropTypes.func.isRequired,
};

EditTester.defaultProps = {
  status: {
    error: false,
  },
};

export default compose(
  withDashboardSidebar,
  withRouter,
  withFormik({
    mapPropsToValues: () => ({
      educationLevel: '',
      linkedinUrl: '',
      jobInfo: 'job_title',
      currentPosition: {
        company: {
          name: '',
          size: '',
          industry: '',
        },
        startDate: {
          month: '',
          year: '',
        },
        endDate: null,
        title: '',
        description: '',
        seniority: '',
      },
    }),
    handleSubmit: async (values, { props, setStatus }) => {
      const attributes = {
        currentPosition: JSON.stringify(values.currentPosition),
        educationLevel: values.educationLevel,
        linkedinUrl: values.linkedinUrl,
        jobsSelected: values.jobsSelected.map((item) => item.id),
        jobInfo: values.jobInfo,
      };

      setStatus({
        isLoading: true,
      });
      try {
        await updateUserCurrentPosition(props.match.params.id, attributes);
        setStatus({
          isLoading: false,
        });
        props.history.push('/testers');
      } catch (error) {
        setStatus({
          isLoading: false,
          error: true,
        });
      } finally {
        setStatus({
          isLoading: false,
        });
      }
    },
  }),
)(EditTester);
